"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:layout": "section",
  "ui:options": {
    "collapsible": true,
    "grid": true,
    "spacing": 2
  },
  "ui:preview": {
    "select": {
      "description": "description"
    },

    prepare({
      formData
    }) {
      return {
        description: formData && formData.title || "Uten tittel"
      };
    }

  },
  "ui:title": "Tilstandsvurdering",
  "ui:label": false,
  "ui:fieldset": ["title", "purposeId", "description", "completedAt"],
  "title": {
    "ui:title": "Tittel"
  },
  "description": {
    "ui:title": "Beskrivelse av formål",
    "ui:widget": "textarea"
  },
  "purposeId": {
    "ui:title": "Årsak til vurdering",
    "ui:widget": "radio"
  },
  "completedAt": {
    "ui:title": "Dato utført"
  }
};
exports.default = _default;
module.exports = exports.default;